import { render } from "./DBody.vue?vue&type=template&id=7fa6e00b&scoped=true"
import script from "./DBody.vue?vue&type=script&lang=js"
export * from "./DBody.vue?vue&type=script&lang=js"

import "./DBody.vue?vue&type=style&index=0&id=7fa6e00b&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa6e00b"]])

export default __exports__